import { render, staticRenderFns } from "./SentEmails.vue?vue&type=template&id=cb04e124&scoped=true&"
import script from "./SentEmails.vue?vue&type=script&lang=ts&"
export * from "./SentEmails.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/helpdesk/sent-emails.css?vue&type=style&index=0&id=cb04e124&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb04e124",
  null
  
)

export default component.exports